import React, { useEffect, useState } from 'react';
import { Button } from 'react-bootstrap';


export default function DGLTH_receipt({ item, entity = null }) {

    function downloadXml() {
        const xmlString = item.xml;

        const blob = new Blob([xmlString], { type: 'application/xml' });
        const url = URL.createObjectURL(blob);

        const a = document.createElement('a');
        a.href = url;
        a.download = 'file.xml';

        document.body.appendChild(a);
        a.click();
        
        a.remove();
    }


    return (
        <>
            <Button size="sm" onClick={() => downloadXml()}>Download XML</Button>
        </>
    )
};